import React, { useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { CloudArrowUpIcon, XMarkIcon, ArrowPathIcon } from '@heroicons/react/24/outline';

const PublishModal = ({ isOpen, toggle, onPublish, publishing }) => {
  const [changeDescription, setChangeDescription] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onPublish(changeDescription || 'Manual workflow edit');
  };

  const handleClose = () => {
    if (!publishing) {
      setChangeDescription('');
      toggle();
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose} size="md">
      <ModalHeader
        toggle={handleClose}
        className="bg-violet-800 text-xl text-white pt-4 pb-3"
        close={
          <button className="-mt-1 text-white" onClick={handleClose} disabled={publishing}>
            <XMarkIcon className="h-6 w-6" />
          </button>
        }
      >
        <span className="flex items-center gap-2">
          <CloudArrowUpIcon className="h-5 w-5" />
          Publish Workflow Changes
        </span>
      </ModalHeader>

      <form onSubmit={handleSubmit}>
        <ModalBody className="p-6">
          <div className="space-y-4">
            <p className="text-sm text-gray-600 dark:text-gray-400">
              This will save the workflow changes to the database and sync them to the live n8n workflow. A new version will be created.
            </p>

            <div>
              <label htmlFor="change-description" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Change Description
              </label>
              <textarea
                id="change-description"
                value={changeDescription}
                onChange={(e) => setChangeDescription(e.target.value)}
                placeholder="Describe what you changed..."
                rows={3}
                className="block w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-violet-500 resize-none"
              />
            </div>
          </div>
        </ModalBody>

        <ModalFooter className="bg-light">
          <button
            type="button"
            onClick={handleClose}
            className="btn btn-outline-secondary"
            disabled={publishing}
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={publishing}
            className="btn bg-violet-700 hover:bg-violet-800 text-white disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            {publishing ? (
              <>
                <ArrowPathIcon className="w-4 h-4 inline mr-1 -mt-0.5 animate-spin" />
                Publishing...
              </>
            ) : (
              <>
                <CloudArrowUpIcon className="w-4 h-4 inline mr-1 -mt-0.5" />
                Publish
              </>
            )}
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default PublishModal;
